<template>
  <div id="dice-game" class="game">
    <router-link to="/" tag="div" class="close">×</router-link>
    <h1>Dice</h1>
    <form class="game-wrapper layout-1" @submit="play">
      <div class="layout-content">
        <div v-if="value" id="dice" :data-value="value" :class="{'up': up}">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="layout-navigation"><button class="action-button">Drop the dice</button></div>
    </form>
  </div>
</template>

<script>

import Random from './../utils/random'

export default {
  data: function () {
    return {
      'value': null,
      'up': true
    }
  },
  methods: {
    play: function (e) {
      e.preventDefault();
      if (this.$data.up){
        this.down();
      } else {
        this.$data.up = true;
        setTimeout(this.down.bind(this), 250);
      }
    },
    down: function () {
      this.$data.value = Random.getNumber(1, 6);
      setTimeout(() => this.$data.up = false, 1);
    }
  }
}
</script>

<style src="./../assets/css/game.css" scoped></style>
<style scoped>

  #dice-game {
    background: #d59a5c url('../assets/img/game/dices/bg.jpg');
  }

  #dice {
    width: 300px;
    height: 300px;
    background: rgba(223,0,0,0.9);
    border-radius: 20px;
    box-shadow: 0 0 225px 0 rgba(0,0,0,0.28) inset, 0 0 90px rgba(0,0,0,0.35);
    position: absolute;
    text-indent: -10000px;
    overflow: hidden;
    transition: all 0.25s ease-out;
    top: 50%;
    right: 50%;
    margin-top: -150px;
    margin-right: -150px;
  }

  #dice.up {
    transform: scale(1.5) rotate(360deg);
    margin-top: -250px;
    margin-right: -200px;
  }

  #dice > div {
    display: none;
    width: 60px;
    height: 60px;
    margin-left: -30px;
    margin-top: -30px;
    position: absolute;
    border-radius: 30px;
    background: #ffffff;
    box-shadow: 1px 1px 1px rgba(0,0,0,0.7) inset;
  }

  #dice.up > div {
    filter: blur(0.25rem);
  }

  #dice[data-value="1"] > div:nth-child(1),
  #dice[data-value="2"] > div:nth-child(1),
  #dice[data-value="2"] > div:nth-child(2),
  #dice[data-value="3"] > div:nth-child(1),
  #dice[data-value="3"] > div:nth-child(2),
  #dice[data-value="3"] > div:nth-child(3),
  #dice[data-value="4"] > div:nth-child(1),
  #dice[data-value="4"] > div:nth-child(2),
  #dice[data-value="4"] > div:nth-child(3),
  #dice[data-value="4"] > div:nth-child(4),
  #dice[data-value="5"] > div:nth-child(1),
  #dice[data-value="5"] > div:nth-child(2),
  #dice[data-value="5"] > div:nth-child(3),
  #dice[data-value="5"] > div:nth-child(4),
  #dice[data-value="5"] > div:nth-child(5),
  #dice[data-value="6"] > div:nth-child(1),
  #dice[data-value="6"] > div:nth-child(2),
  #dice[data-value="6"] > div:nth-child(3),
  #dice[data-value="6"] > div:nth-child(4),
  #dice[data-value="6"] > div:nth-child(5),
  #dice[data-value="6"] > div:nth-child(6) {
    display: block;
  }

  #dice > div:nth-child(1),
  #dice > div:nth-child(5) {
    top: 25%;
    left: 25%;
  }

  #dice > div:nth-child(2) {
    top: 75%;
    left: 75%;
  }
  #dice > div:nth-child(3) {
    top: 25%;
    left: 75%;
  }

  #dice > div:nth-child(4) {
    top: 75%;
    left: 25%;
  }

  #dice[data-value="1"] > div:nth-child(1),
  #dice[data-value="3"] > div:nth-child(3),
  #dice[data-value="5"] > div:nth-child(1) {
    top: 50%;
    left: 50%;
  }

  #dice[data-value="6"] > div:nth-child(5) {
    top: 50%;
    left: 25%;
  }

  #dice > div:nth-child(6) {
    top: 50%;
    left: 75%;
  }

  @media all and (max-width: 919px) {
    #dice {
      width: 200px;
      height: 200px;
      margin-top: -100px;
      margin-right: -100px;
    }
    #dice > div {
      width: 40px;
      height: 40px;
      margin-left: -20px;
      margin-top: -20px;
    }
  }


</style>
